let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hFl5P")).then(() => parcelRequire('gusPx'));